module.exports = __webpack_public_path__ + "img/brands.b8aa2fc3.svg";